export function makeAccount(payload) {
  let account = new Account();
  account.availableBalance = payload.available;
  account.unallocatedBalance = payload.unallocated;

  return account;
}

export class Account {
  construct() {
    this._availableBalance = null;
    this._unallocatedBalance = null;
  }

  set availableBalance(availableBalance) {
    this._availableBalance = availableBalance;
  }

  get availableBalance() {
    return this._availableBalance;
  }

  set unallocatedBalance(unallocatedBalance) {
    this._unallocatedBalance = unallocatedBalance;
  }

  get unallocatedBalance() {
    return this._unallocatedBalance;
  }
} 



// WEBPACK FOOTER //
// ./client/app/api/models/account.model.js